"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _BrandInfoWizard = _interopRequireDefault(require("./BrandInfoWizard"));

var _SubBrand = _interopRequireDefault(require("../contexts/SubBrand"));

require("../styles/_brand-info.scss");

var _brandWizardSteps = _interopRequireDefault(require("./WizardAssetStep/constants/brandWizardSteps"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // ES lint can not detect State variables are being used in other wizard rendered component's
// Unecessary warnings are ignored


var BrandInfoRoot = /*#__PURE__*/function (_Component) {
  _inherits(BrandInfoRoot, _Component);

  var _super = _createSuper(BrandInfoRoot);

  function BrandInfoRoot(props) {
    var _this;

    _classCallCheck(this, BrandInfoRoot);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fetchData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, getOrganisationSubBrand, fetchAssets, _yield$getOrganisatio, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, getOrganisationSubBrand = _this$props.getOrganisationSubBrand, fetchAssets = _this$props.fetchAssets;

              if (getOrganisationSubBrand) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                loading: false
              }));

            case 3:
              _context.prev = 3;

              _this.setState({
                loading: true
              });

              _context.next = 7;
              return getOrganisationSubBrand();

            case 7:
              _yield$getOrganisatio = _context.sent;
              data = _yield$getOrganisatio.data;
              error = _yield$getOrganisatio.error;

              if (!error) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                error: error,
                loading: false
              }));

            case 12:
              if (!(!data || !data.getOrganisationSubBrand)) {
                _context.next = 14;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                error: 'no data',
                loading: false
              }));

            case 14:
              _this.setState({
                subBrand: data.getOrganisationSubBrand,
                loading: false
              });

              fetchAssets(data.getOrganisationSubBrand);
              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](3);
              return _context.abrupt("return", void _this.setState({
                error: _context.t0
              }));

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 18]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "gotoPage", function (stage) {
      var history = _this.props.history;
      var subBrand = _this.state.subBrand;

      if (subBrand && subBrand.subBrandId) {
        return void history.push("/brand/edit/".concat(subBrand.subBrandId, "#").concat(stage));
      }

      history.push('/brand/edit');
    });

    _defineProperty(_assertThisInitialized(_this), "completeForm", function () {
      var history = _this.props.history;
      var subBrand = _this.state.subBrand;

      if (subBrand && subBrand.subBrandId) {
        return void history.push("/brand/".concat(subBrand.subBrandId));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "gotoPrevPage", function () {
      var step = _this.getCurrentPage();

      if (step <= 1) {
        return;
      }

      _this.gotoPage(step - 1);
    });

    _defineProperty(_assertThisInitialized(_this), "gotoNextPage", function () {
      var step = _this.getCurrentPage();

      if (step >= 6) {
        return void _this.completeForm();
      }

      return void _this.gotoPage(step + 1);
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentPage", function () {
      var location = _this.props.history.location;

      if (!location.hash) {
        return 1;
      }

      return parseInt(location.hash.substring(1), 10);
    });

    _defineProperty(_assertThisInitialized(_this), "stripKeysAndAddPosition", function (subBrand) {
      return function (strippedObj, key) {
        if (subBrand[key]) {
          return _objectSpread(_objectSpread({}, strippedObj), {}, _defineProperty({}, key, subBrand[key].map(function (_ref2, index) {
            var groupKey = _ref2.key,
                rest = _objectWithoutProperties(_ref2, ["key"]);

            return _objectSpread(_objectSpread({}, rest), {}, {
              position: index
            });
          })));
        }

        return strippedObj;
      };
    });

    _defineProperty(_assertThisInitialized(_this), "updateSubBrand", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(newSubBrand) {
        var upsertOrganisationSubBrand, keysToStrip, strippedNewSubBrand, _yield$upsertOrganisa, data, error, updateOrganisationSubBrand, createOrganisationSubBrand, upsertOrganisationSubBrandData;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                upsertOrganisationSubBrand = _this.props.upsertOrganisationSubBrand;
                keysToStrip = [].concat(_toConsumableArray(Object.keys(_brandWizardSteps.default)), ['brandValues']);
                strippedNewSubBrand = _objectSpread(_objectSpread({}, newSubBrand), keysToStrip.reduce(_this.stripKeysAndAddPosition(newSubBrand), {}));

                _this.setState(function (_ref4) {
                  var oldSubBrand = _ref4.subBrand;
                  return {
                    subBrand: _objectSpread(_objectSpread({}, oldSubBrand), strippedNewSubBrand)
                  };
                });

                _context2.next = 7;
                return upsertOrganisationSubBrand(strippedNewSubBrand);

              case 7:
                _yield$upsertOrganisa = _context2.sent;
                data = _yield$upsertOrganisa.data;
                error = _yield$upsertOrganisa.error;

                if (!error) {
                  _context2.next = 12;
                  break;
                }

                return _context2.abrupt("return", void _this.setState({
                  error: error
                }));

              case 12:
                if (data) {
                  _context2.next = 14;
                  break;
                }

                return _context2.abrupt("return", void _this.setState({
                  error: 'no data'
                }));

              case 14:
                updateOrganisationSubBrand = data.updateOrganisationSubBrand, createOrganisationSubBrand = data.createOrganisationSubBrand;
                upsertOrganisationSubBrandData = updateOrganisationSubBrand || createOrganisationSubBrand;

                _this.setState(function (_ref5) {
                  var oldSubBrand = _ref5.subBrand;
                  return {
                    subBrand: _objectSpread(_objectSpread({}, oldSubBrand), {}, {
                      subBrandId: upsertOrganisationSubBrandData.subBrandId
                    })
                  };
                });

                _this.gotoNextPage();

                _context2.next = 24;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2["catch"](0);
                (0, _commonReact.createNotification)({
                  type: 'error',
                  content: _context2.t0
                });
                return _context2.abrupt("return", void _this.setState({
                  error: _context2.t0
                }));

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 20]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "renderWizard", function () {
      var subBrand = _this.state.subBrand;
      return /*#__PURE__*/_react.default.createElement(_SubBrand.default.Provider, {
        value: {
          subBrand: subBrand,
          updateSubBrand: _this.updateSubBrand
        }
      }, /*#__PURE__*/_react.default.createElement(_BrandInfoWizard.default, {
        onBack: _this.gotoPrevPage,
        initialStage: _this.getCurrentPage()
      }));
    });

    _this.state = {
      loading: true
    };
    return _this;
  }

  _createClass(BrandInfoRoot, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchData();
    }
  }, {
    key: "render",
    value: function render() {
      var history = this.props.history;
      var _this$state = this.state,
          loading = _this$state.loading,
          error = _this$state.error,
          _this$state$subBrand = _this$state.subBrand;
      _this$state$subBrand = _this$state$subBrand === void 0 ? {} : _this$state$subBrand;
      var subBrandId = _this$state$subBrand.subBrandId;
      var backUrl = subBrandId ? "/brand/".concat(subBrandId) : '/';

      if (error) {
        return /*#__PURE__*/_react.default.createElement(_commonReact.Error, null);
      }

      if (loading) {
        return /*#__PURE__*/_react.default.createElement(_uiKit.Loader, null);
      }

      var content = this.renderWizard();
      return /*#__PURE__*/_react.default.createElement(_uiKit.ClosablePage, {
        className: "brand-info",
        history: history,
        backUrl: backUrl
      }, content);
    }
  }]);

  return BrandInfoRoot;
}(_react.Component);

var _default = BrandInfoRoot;
exports.default = _default;